import formatStandardRupee from "./format-standard-currency";
import ProgressBar from "./progress-bar";

const Component2 = ({
  bg,
  title,
  icon1,
  highlightColor,
  progressColor,
  icon2,
  progressLable,
  status,
  value,
  progressPercent,
  statusValue,
  settledValue,
  settled,
}) => {
  return (
    <div
      className={`w-full h-[160px]  p-[12px] rounded-[12px] flex flex-col `}
      style={{ backgroundColor: bg }}
    >
      <div className="flex justify-between">
        <label className="font-[var(--trans-stats-con-value-fw)] text-[length:var(--trans-stats-con-value1-fs)] leading-4 align-middle text-[var(--bill-list-payMet-desc-fg)] mb-[8px]">
          {title}
        </label>{" "}
        {icon1}
      </div>
      <div className="flex space-x-[4px] mb-[12px]">
        <label className="font-[var(--trans-stats-con-label1-fw)] text-[length:var(--trans-stats-con-label1-fs)] leading-6 align-middle ">
          {statusValue}
        </label>
        <label
          className={`font-[var(--trans-stats-con-value-fw)] text-[length:var(--trans-stats-con-label-fs)] leading-6 align-middle `}
          style={{ color: highlightColor }}
        >
          {status}
        </label>
      </div>
      <div>
        <div className="justify-center text-black text-base font-bold  leading-normal mb-[4px]">
          ₹ {formatStandardRupee(value)}
        </div>
      </div>
      <div className="flex flex-row  justify-between  text-[length:var(--trans-stats-con-label-fs)] leading-[16px] font-[var(--trans-stats-con-value-fw)]">
        <label className="  align-middle">{progressLable}</label>
        <label style={{ color: highlightColor }}>{progressPercent}%</label>
      </div>
      <ProgressBar
        value={progressPercent}
        progressColor={progressColor}
        divClass="my-[4px]"
      />
      <div>
        <div className="flex flex-row items-center space-x-[4px] text-[length:var(--trans-stats-con-label-fs)] font-medium  leading-none">
          {icon2}
          <label className="text-[#00000066] leading-4 pt-[1px] ">
            {" "}
            {settled}: {settledValue}
            {/* days ago */}
          </label>
        </div>
      </div>
    </div>
  );
};
export default Component2;
